// extracted by mini-css-extract-plugin
export var businessUnit = "SuggestedContentSection-module--businessUnit--9eece";
export var content = "SuggestedContentSection-module--content--67bb7";
export var divider = "SuggestedContentSection-module--divider--686d7";
export var heading = "SuggestedContentSection-module--heading--da31f";
export var holder = "SuggestedContentSection-module--holder--e2e9e";
export var suggestedContentCta = "SuggestedContentSection-module--suggestedContentCta--6bf97";
export var suggestedContentResults = "SuggestedContentSection-module--suggestedContentResults--75981";
export var title = "SuggestedContentSection-module--title--958d2";
export var wrapper = "SuggestedContentSection-module--wrapper--a50f9";